/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchPaymentRequests200ResponseInnerRequestor } from './search-payment-requests200-response-inner-requestor';
// May contain unused imports in some cases
// @ts-ignore
import { SearchPaymentRequests200ResponseInnerSupplier } from './search-payment-requests200-response-inner-supplier';

/**
 * 
 * @export
 * @interface SearchPaymentRequests200ResponseInner
 */
export interface SearchPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {SearchPaymentRequests200ResponseInnerSupplier}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'supplier': SearchPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'status': SearchPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {SearchPaymentRequests200ResponseInnerRequestor}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestor': SearchPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const SearchPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type SearchPaymentRequests200ResponseInnerStatusEnum = typeof SearchPaymentRequests200ResponseInnerStatusEnum[keyof typeof SearchPaymentRequests200ResponseInnerStatusEnum];


